
import OpenChatReportApi from '@/api/OpenChatReportApi'
import { getTodayNowTime, getTodayStartTime } from '@/utils/date.util'

import { defineComponent, onBeforeUnmount, onMounted, reactive, ref } from 'vue'

export default defineComponent({
  setup () {
    let timer = 0
    const solvePercent = ref(0)
    const solveDurationData = reactive([
      {
        label: '平均等待时长(S)',
        value: '--'
      },
      {
        label: '最大等待时长(S)',
        value: '--'
      },
      {
        label: '平均会话时长(M)',
        value: '--'
      },
      {
        label: '平均响应时长(M)',
        value: '--'
      }
    ])

    // 平均等待时长
    const getAvgChatWaitingSeconds = OpenChatReportApi.getAvgChatWaitingSeconds({
      startDate: getTodayStartTime(),
      endDate: getTodayNowTime()
    })
    // 最大等待时长
    const getMaxChatWaitingSeconds = OpenChatReportApi.getMaxChatWaitingSeconds({
      startDate: getTodayStartTime(),
      endDate: getTodayNowTime()
    })
    // 平均会话时长
    const getAvgChatSeconds = OpenChatReportApi.getAvgChatSeconds({
      startDate: getTodayStartTime(),
      endDate: getTodayNowTime()
    })
    // 平均响应时长
    const getAvgChatRoundResponseSeconds = OpenChatReportApi.getAvgChatRoundResponseSeconds({
      startDate: getTodayStartTime(),
      endDate: getTodayNowTime()
    })
    // 解决率
    const getChatSolvedRate = OpenChatReportApi.getChatSolvedRate({
      startDate: getTodayStartTime(),
      endDate: getTodayNowTime()
    })

    function loadData () {
      return Promise.all([
        getAvgChatWaitingSeconds,
        getMaxChatWaitingSeconds,
        getAvgChatSeconds,
        getAvgChatRoundResponseSeconds,
        getChatSolvedRate
      ]).then(data => {
        const d0 = (data[0] && data[0].length > 0 && !!data[0][0]) ? data[0][0] : { 
          avgWaitingSeconds: 0
        }
        solveDurationData[0].value = d0.avgWaitingSeconds

        const d1 = (data[1] && data[1].length > 0 && !!data[1][0]) ? data[1][0] : { 
          maxWaitingSeconds: 0
        }
        solveDurationData[1].value = d1.maxWaitingSeconds

        const d2 = (data[2] && data[2].length > 0 && !!data[2][0]) ? data[2][0] : { 
          avgSeconds: 0
        }
        solveDurationData[2].value = (d2.avgSeconds / 60).toFixed(2)

        const d3 = (data[3] && data[3].length > 0 && !!data[3][0]) ? data[3][0] : { 
          avgRoundResponseSeconds: 0
        }
        solveDurationData[3].value = (d3.avgRoundResponseSeconds / 60).toFixed(2)

        const d4 = (data[4] && data[4].length > 0 && !!data[4][0]) ? data[4][0] : { 
          solvedRate: 0
        }
        solvePercent.value = parseFloat((d4.solvedRate * 100).toFixed(2))

        timer = setTimeout(() => {
          loadData();
        }, 5000)
      })
    }

    onMounted(() => {
      loadData();
    })

    onBeforeUnmount(() => {
      clearTimeout(timer);
    })

    return {
      solvePercent,
      solveDurationData
    }
  }
})
